import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Safe: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.807 13.2l-1.28-1.067-3.66 4.392-2.7-2.025-1 1.333 3.967 2.975 4.673-5.608z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 7.622l8.512 2.837-2.79 10.228L16 24.501l-5.722-3.814-2.79-10.228L16 7.622zm0 1.756l-6.488 2.163 2.21 8.105L16 22.498l4.278-2.852 2.21-8.105L16 9.378z"
        fill={color}
      />
    </svg>
  );
};

export default Safe;
